<template>
	<b-row>
		<b-col cols="12" lg="4" offset-lg="2">
			<slot name="jay"></slot>
		</b-col>
		<b-col cols="12" lg="4">
			<slot name="bob"></slot>
		</b-col>
	</b-row>
</template>

<script>
	//const axios = require('axios');
	export default {
		data() {
			return {
			
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>